import { gql } from '@apollo/client';

export const CORE_CONTACT_FIELDS = gql`
    fragment CoreContactFields on Contact {
        id
        recordId
        firstName
        lastName
        photoUrl
        suffix
        title
        status
    }
`;
